import { render, staticRenderFns } from "./RotatingSolids.vue?vue&type=template&id=12add0dc&scoped=true&"
import script from "./RotatingSolids.vue?vue&type=script&lang=js&"
export * from "./RotatingSolids.vue?vue&type=script&lang=js&"
import style0 from "./RotatingSolids.vue?vue&type=style&index=0&id=12add0dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12add0dc",
  null
  
)

export default component.exports